<!-- Sidepanel Right Search Customer -->
<aside  [ngClass]="{'active':  navService.isTimeZoneModalOpen }"
    class="footer-sidepanel footer-sidepanel--customer-search footer-sidepanel--timezone">
    <div class="footer-sidepanel__header">
        <h5><i class="fa-thin fa-earth-americas"></i>Time Zones</h5>
        <a (click)="navService.toggleTimeZoneModal()"><i class="fa-light fa-xmark"></i></a>
    </div>
    <div *ngIf="navService.isTimeZoneModalOpen" class="footer-sidepanel__content">
        <div class="flex-row flex-row--no-pad">
            <div class="flex-col-xs-7 timezone-label">
                <div class="city">
                    <div class="city-name">America/New York</div>
                    <div class="day">Eastern Time <span class="difference">GMT-4:00</span></div>
                </div>
            </div>
            <div class="flex-col-xs-5">
                <app-gauge-clock timeZone="EST"></app-gauge-clock>
            </div>
            <div class="flex-col-xs-7 timezone-label">
                <div class="city">
                    <div class="city-name">America/Chicago</div>
                    <div class="day">Central Time <span class="difference">GMT-6:00</span></div>
                </div>
            </div>
            <div class="flex-col-xs-5">
                <app-gauge-clock timeZone="CT"></app-gauge-clock>
            </div>
            <div class="flex-col-xs-7 timezone-label">
                <div class="city">
                    <div class="city-name">America/Phoenix</div>
                    <div class="day">Mountain Time <span class="difference">GMT-07:00</span></div>
                </div>
            </div>
            <div class="flex-col-xs-5">
                <app-gauge-clock timeZone="MT"></app-gauge-clock>
            </div>
            <div class="flex-col-xs-7 timezone-label">
                <div class="city">
                    <div class="city-name">America/Los Angeles</div>
                    <div class="day">Pacific Time <span class="difference">GMT-08:00</span></div>
                </div>
            </div>
            <div class="flex-col-xs-5">
                <app-gauge-clock timeZone="PT"></app-gauge-clock>
            </div>
        </div>

    </div>
</aside>